var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user && _vm.user.impersonate)?_c('v-alert',{attrs:{"type":"warning","text":""}},[_c('i18n',{attrs:{"path":"users.logged_as"}},[_c('strong',[_vm._v(_vm._s(_vm.user.name))]),_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":_vm.stopImpersonate}},[_vm._v(_vm._s(_vm.$t('here')))])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }